module.exports = __webpack_public_path__ + "np.fed92a40dfeccd235896.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/np.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/np.svg
// module chunks = styles